// @ts-nocheck
import createProgramsListWidget from './createProgramsListWidget';
import { isResponsiveEditor } from '@wix/santa-editor-utils';
export default ({ editorAPI }) =>
  createProgramsListWidget({
    editorAPI,
    isEditorX: isResponsiveEditor(),
  });
